import notificationsOnPage from "./notifications-on-page/directive";
import notification from "./notification/directive";
import notificationService from "./service";

const modul = angular
    .module("NotificationsModule", [])

    .directive("notification", notification)
    .directive("notificationsOnPage", notificationsOnPage)
    .service("notificationService", notificationService);

export default modul.name;
